import type { QuantityInfo } from 'apiConnector/secondary-market/shared/referential';
import type { ISalesCounterpart } from 'models/ISalesCounterpart';
import type {
  SecondaryPriceType,
  SecondaryQuotationType,
} from 'state/secondaryMarket/productSearch/productSearch.model';
import type { OtcClient } from 'state/secondaryMarket/shared/referential/referential.model';
import type { Collection } from 'state/utils/types';

export type CpOrderBcsProduct = {
  name?: string;
  isin?: string;
  fileCode?: string;
  denomination?: number;
  currency?: string;
  traderGroup?: string;
  salesMargin?: number;
  bid?: number;
  ask?: number;
  extraBid?: number;
  extraAsk?: number;
  maturityDate?: string;
  quotationType?: SecondaryQuotationType;
  priceType?: SecondaryPriceType;
  clients?: ISalesCounterpart[];
  portfolio?: string;
  cpTradeAuthorisation?: CpTradeAuthorisation;
  traderLabel?: string;
  traderMessage?: string;
  salesMessage?: string;
  ric?: string;
};

export type CutOff = Readonly<{
  limitTime: string;
  nextCutOff: Date | undefined;
  zoneId: string;
}>;

export type DominoBookingParams = Readonly<{
  valuationDates?: ReadonlyArray<string>;
  cutOff?: CutOff;
  settlementHolidays?: ReadonlyArray<string>;
  otcDealPositions?: ReadonlyArray<OtcClient>;
}>;

export type CpTradeAuthorisation = 'Bid only' | 'Full' | 'Ask only';
export type Product = {
  dominoProduct: DominoBookingParams | undefined;
  bcsProduct: CpOrderBcsProduct | undefined;
  quantityInfo?: QuantityInfo;
  errors: string[];
  warnings: string[];
  infos: string[];
};

export type ProductMap = Collection<Product>;

export const initialProductsMap = {};
